export function formatItemPrice(price: number): string {
  const priceInDollars = price / 100;
  return '$' + priceInDollars.toFixed(2);
}
